import { Spinner } from "./Spinner";

export function LoadingContainer() {
    return (
        <div className="d-flex justify-content-center align-items-center py-5">
            <div>
                <Spinner />
            </div>
        </div>
    );
}
